import React from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import PropTypes from "prop-types"
import { t } from "i18next"
import InputRHF from "components/RHF/InputRHF"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import LoadingButton from "components/Common/LoadingButton"
import { createFolderTemplate } from "api/folderTemplateApi"

function CreateTemplateModal({ isOpen, toggle, ...otherProps }) {
  const queryClient = useQueryClient()

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      name: "",
      keywords: "",
    },
  })

  const { mutate, isPending } = useMutation({
    mutationFn: createFolderTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries(["folder_templates"])
      reset()
      toggle()
    },
    onError: error => toast.error(error),
  })

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} {...otherProps}>
      <ModalHeader toggle={toggle}>
        {t("add a new template folder")}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(mutate)} id="form_id">
          <InputRHF
            name="name"
            label={t("name")}
            placeholder={t("enter template name")}
            control={control}
          />
          <InputRHF
            type="textarea"
            name="keywords"
            label={t("keywords")}
            placeholder={t("enter template keywords")}
            control={control}
          />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button outline color="danger" onClick={toggle}>
          {t("cancel")}
        </Button>
        <LoadingButton
          isLoading={isPending}
          type="submit"
          color="primary"
          form="form_id"
        >
          {t("create")}
        </LoadingButton>
      </ModalFooter>
    </Modal>
  )
}
CreateTemplateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
export default CreateTemplateModal
